(ns practitest.frontend.components2.issue-status
  (:require
    [clojure.string :as str]
    [practitest.frontend.common.i18n :refer [get-translation]]))

;; Some hardcoded issues statuses colors as in figma:
;;https://www.figma.com/file/0aTwitb3NTlNHmCpBFb3XA/Practitest-UX-Clients?type=design&node-id=2869-133792&mode=dev

(def statuses-map
  {"new"      {:label (get-translation "issue-status.new" "new")
               :color "var(--pt-color-issue-new)"}
   "opened"   {:label (get-translation "issue-status.opened" "opened")
               :color "var(--pt-color-issue-opened)"}
   "assigned" {:label (get-translation "issue-status.assigned" "assigned")
               :color "var(--pt-color-issue-assigned)"}
   "fixed"    {:label (get-translation "issue-status.fixed" "fixed")
               :color "var(--pt-color-issue-fixed)"}
   "closed"   {:label (get-translation "issue-status.closed" "closed")
               :color "var(--pt-color-issue-closed)"}
   "rejected" {:label (get-translation "issue-status.rejected" "rejected")
               :color "var(--pt-color-issue-rejected)"}})
(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        ;; Use label itself here
        status)))

(defn get-status-color
  [status]
  (:color (get statuses-map status)))

(defn issue-status-component
  [status]
  [:<>
   (when (and status (not (str/blank? status)))
     (when-let [color (get-status-color (str/lower-case status))]
       [:span.status-indicator
        {:style {:color color}}]))
   (get-status-label status)])
